export const readablePlatformNames = {
    twitch: 'Twitch',
    youtube: 'YouTube',
    tiktok: 'TikTok',
} as const
